import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  Commentary,
  CommentaryTypeLabel,
  UserCommentary,
} from '../commentary.types';
import { RenderHighlightedParts } from '../../components/highlight/RenderHighlightedParts';
import { Highlight } from '../../components/highlight/Highlight';
import styles from './commentary_link_content.module.scss';

type Props = {
  commentary: Commentary | UserCommentary;
  isDoctrineLink?: boolean;
};

export const CommentaryLinkContent: FC<Props> = ({
  commentary,
  isDoctrineLink = false,
}) => (
  <div className={styles.container}>
    <div>
      <div className={styles.link}>
        <RenderHighlightedParts
          config={{
            preTag: 'highlight_start',
            postTag: 'highlight_stop',
          }}
          renderHighlightedParts={renderCallback}
        >
          {commentary.title}
        </RenderHighlightedParts>
      </div>
      <div
        className={classNames(
          styles.subtext,
          commentary.typeLabel === CommentaryTypeLabel.PAPER && styles.paper,
        )}
      >
        {commentary.author && (
          <span className={styles.item}>{commentary.author}</span>
        )}

        {commentary.sourceName && (
          <span className={styles.item}>{commentary.sourceName}</span>
        )}
        {isDoctrineLink && (
          <span className={styles.item}>
            <FormattedMessage id="CommentaryLinkContent/2" />
          </span>
        )}
        {commentary.dateHtml && (
          <span
            className={classNames(styles.date, {
              [styles.datePaper]:
                commentary.typeLabel === CommentaryTypeLabel.PAPER,
              [styles.paper]:
                commentary.author || commentary.sourceName || isDoctrineLink,
            })}
            dangerouslySetInnerHTML={{
              __html: commentary.dateHtml,
            }}
          />
        )}
      </div>
    </div>

    {!isDoctrineLink && (
      <div className={styles.info}>
        {commentary.typeLabel === CommentaryTypeLabel.HYBRID && (
          <span className={styles.text}>
            <FormattedMessage id="CommentaryLinkContent/1" />
          </span>
        )}
      </div>
    )}
  </div>
);

function renderCallback(
  {
    value,
    highlighted,
  }: {
    value: string;
    highlighted: boolean;
  },
  index: number,
) {
  if (highlighted) return <Highlight key={index}>{value}</Highlight>;
  return value;
}
